module.exports = "/images/Sub-What we do-02.jpg";